/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 * @flow
 */

import slugify from 'slugify';

/**
 * slugify the assets based on parameters
 *
 * @param string string - file/snippet/asset name
 * @param string directory? - directory
 */
export default (string: string, directory?: string): string => {
  const filename = slugify(string) + '.html';

  return directory ? `/${directory}/${filename}` : filename;
};
